
import type {CoseQueryBodyRequestWithContext} from '../../../models/cose-api/request/query-body-request.model';
import {makeLogger} from '../../../logger/logger';
import type {GuidedMiddleware} from '../models/middleware';
import type {GuidedApiCallParams, GuidedItemsV2} from '../models/models';


const {
  //info,
  // debug,
  // warn,
  err
} = makeLogger({
  pathToCurrentFile: 'components/guided2/middlewares/apiCallCose.ts',
});

const errorItem = (searcher, e)=>{return {
  searcher: 'error/' + searcher,
  score: 0,
  template: 'backend-error',
  category: 'backend-error',
  details: {
    quickLinkTitle: (e as Error)?.message ?? e.toString(),
    quickLinkOpenUrl: '#',
  }
};
};

const callCoseApi:GuidedMiddleware = async(params: GuidedApiCallParams, _next):Promise<GuidedItemsV2>=>{

    // info('Enter callCoseSuggestionsApi middleware', {params});

    const requestBody: CoseQueryBodyRequestWithContext = {
      searcher: params.guidedRequest.searcher,
      context: params.guidedRequest.context,
      // term: params.dataflux.root.searchTerm, //this is original term
      term: params.guidedRequest.searchTerm, //this is altered by prev middleware
      limitPerGroup: params.guidedRequest.limitPerGroup, //if undefined, is not rendered
      groupOptions: params.guidedRequest.groupOptions,
    };

    const cacheBusting = (()=>{
        const apigeeValue = new URLSearchParams(window.location.search).get('apigee');
        if(apigeeValue == 'monitoring'){
          return {'Bypass-Cache':'true'};
        }else return {};
    })();

    const apiEndpoint = (()=>{
        const base = params.guidedRequest.apiEndpoint;
        const url = new URL(base);
        url.searchParams.set('searcher', params.guidedRequest.searcher);
        url.searchParams.set('ui-component', 'guidedV2');
        return url.toString();
    })();

    // info('Call real Cose', {params});

    try{
      const apiResponse = await fetch(
        apiEndpoint,
        {
          method: 'POST',
          body: JSON.stringify(requestBody),
          headers:{
            ...params.guidedRequest.auth,
            ...cacheBusting,
            'content-Type': 'application/json',
          }
        }
      );

      if(apiResponse.status !== 200){
        err(`CoseApi backend error, status code: ${apiResponse.status}; message: apiResponse.statusText`, apiResponse);
        return [errorItem(
          params.guidedRequest.searcher,
          new Error('Backend response with status code: ' + apiResponse.status))
        ];
      }

      const data = await apiResponse.json();
      // info('CoseApi backend success', {data, apiResponse});
      // info('Enter callCoseSuggestionsApi middleware - returns data',data);
      return data;
    }catch(e){
      console.error('Error in callCoseSuggestionsApi', e); // eslint-disable-line no-console
      return [errorItem(params.guidedRequest.searcher, e)];
    }
};

export default callCoseApi;
